module.exports = __webpack_public_path__ + "images/FUSA_icons/035-credit-card-3.eabb61e4e1595ed2f371648979ca7a2f.svg";